import React, { useState } from 'react'

export function useDropdownInteraction() {
    const [openDropdown, setOpenDropdown] = useState<boolean>(false)
    const [dropdownElement, setDropdownElement] =
        React.useState<null | HTMLElement>(null)
    const open = Boolean(dropdownElement)
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setDropdownElement(event.currentTarget)
    }
    const handleClose = () => {
        setDropdownElement(null)
    }

    const handleClickBox = () => {
        setOpenDropdown(!openDropdown)
    }

    return {
        handleClick,
        handleClose,
        handleClickBox,
        dropdownElement,
        setDropdownElement,
        setOpenDropdown,
        openDropdown,
        open,
    }
}
